import React from 'react';
import moment from 'moment/moment';
import {useIntl} from 'react-intl';

const PaycheckColumn = ({date, paycheck, splitNum}) => {
  const intl = useIntl();
  const dateLabel = date ? moment(date).format('DD-MM-YYYY') : '';
  const splitNumLabel = splitNum
    ? intl.formatMessage({id: 'TransfersList.splitPart', defaultMessage: 'part {splitNum}'}, {splitNum})
    : '';

  return (
    <div className="text-dark-75 font-weight-bolder font-size-lg d-block text-nowrap ">
      <div>{[dateLabel, splitNumLabel].filter(Boolean).join(' - ')}</div>
      <div>{paycheck || ''}</div>
    </div>
  )
}

export function PaycheckColumnFormatter(date, paycheck, splitNum) {
  return <PaycheckColumn date={date} paycheck={paycheck} splitNum={splitNum}/>;
}
